import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
import { secondsToHHMM } from "../../../Utilitie";

const STAYardPDDChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);
  const [chartData1, setChartData1] = useState([]);

  useEffect(() => {
    const raw = data;

    const monthToNum = (m) => {
      const map = {
        APR: 3,
        MAY: 4,
        JUN: 5,
        JUL: 6,
        AUG: 7,
        SEP: 8,
        OCT: 9,
        NOV: 10,
        DEC: 11,
        JAN: 0,
        FEB: 1,
        MAR: 2,
      };
      return map[m];
    };

    const grouped =
      raw &&
      raw.reduce((acc, cur) => {
        if (!acc[cur.f_year]) {
          acc[cur.f_year] = {
            total_trains: 0,
            total_hrs: 0,

            totalDays: 0,
          };
        }

        acc[cur.f_year].total_trains += Number(cur.total_trains) || 0;
        acc[cur.f_year].total_hrs += cur.total_hrs || 0;

        const daysInMonth = new Date(
          cur.a_year,
          monthToNum(cur.a_month) + 1,
          0
        ).getDate();

        acc[cur.f_year].totalDays += daysInMonth;

        return acc;
      }, {});

    const dimensions = ["product", ...Object.keys(grouped)];

    const seriesTR = { product: "TRAIN AVG PER DAY" };
    const seriesTD = { product: "PDD AVG PER DAY" };

    Object.keys(grouped).forEach((fy) => {
      const g = grouped[fy];

      const trTotal = g.total_trains;
      seriesTR[fy] = Number((trTotal / g.totalDays).toFixed(2));

      const tdTotal = g.total_hrs / g.total_trains;
      seriesTD[fy] = Number(tdTotal.toFixed(2));
    });

    const chart1 = {
      dimensions,
      series: [seriesTR],
    };
    const chart2 = {
      dimensions,
      series: [seriesTD],
    };

    setChartData(chart1);
    setChartData1(chart2);
  }, [data]);

  return (
    <div>
      <h5 className="bg-dark text-white p-3 mb-5">
        STA Traffic Flow Average Per Day{" "}
        <b style={{ fontSize: "13px", color: "#7e7d7dff" }}> </b>{" "}
      </h5>

      <div className="d-flex justify-content-around">
        {" "}
        <div style={{ width: "500px" }}>
          {" "}
          {data.length > 0 && chartData && (
            <GroupedBarChart
              data={chartData}
              rotateText={0}
              from={`Block_C`}
              chartType="bar"
            />
          )}{" "}
        </div>
        <div style={{ width: "500px" }}>
          {data.length > 0 && chartData1 && (
            <GroupedBarChart
              data={chartData1}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default STAYardPDDChart;
